import { gql, useMutation } from '@apollo/client'

export const UPDATE_UNIT = gql`
  mutation ($input: UnitInput) {
    updateUnit(input: $input) {
      id
      alias
      name
    }
  }
`

export const useUpdateUnit = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_UNIT)

  return { mutate, data, loading, error }
}
